import { resellerApiWithToken } from '@api/baseApi'

import Cookies from 'js-cookie'

const scope = Cookies.get('scope')
let path

if (scope === 'reseller') {
  path = '/resellers/withdraws'
} else {
  path = '/affiliates/withdraws'
}

const mapParams = (params) => {
  const newParams = {
    bank_name: params.bank_name,
    account_name: params.account_name,
    bank_account: params.bank_account,
    amount: params.amount,
    bank_account_id: params.bank_account_id,
  }

  return newParams
}

export const getApi = (id, params) => resellerApiWithToken.get(`${path}/${id}`, { params })
export const getCollectionApi = (params) => resellerApiWithToken.get(path, { params })
export const postApi = (params, postPath) => resellerApiWithToken.post(postPath, { reseller_affiliate_withdraw: mapParams(params) })
export const postBankApi = (params, postPath) => resellerApiWithToken.post(postPath, { bank_account: params })
export const editBankApi = (id, params, postPath) => resellerApiWithToken.put(`${postPath}/${id}`, { bank_account: params })
